import { BoxProps } from '@mui/material';
import React, { ReactElement } from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';

export interface StudioClipBadgeWrapperProps
  extends Omit<BoxProps, 'children'> {
  draggableProvided?: DraggableProvided;
  style?: React.CSSProperties;
  children: ReactElement | false;
}

const StudioClipWrapper = ({
  draggableProvided,
  style,
  children,
}: StudioClipBadgeWrapperProps): ReactElement => {
  const styles = getStyles(
    {
      position: 'relative',
      // Note: margin-bottom is being set to 0 to avoid DnD drag issue
      margin: `8px 0px 0px 8px`,
    },
    style,
    draggableProvided
  );
  return (
    <div
      ref={draggableProvided?.innerRef}
      {...(draggableProvided?.draggableProps || {})}
      style={styles}
    >
      {children}
    </div>
  );
};

function getStyles(
  baseStyles: React.CSSProperties,
  propStyles?: React.CSSProperties,
  provided?: DraggableProvided
) {
  let style = baseStyles;
  if (propStyles) {
    style = Object.assign(style, propStyles);
  }
  if (provided && provided.draggableProps.style) {
    style = Object.assign(style, provided.draggableProps.style);
  }
  return style;
}

export default StudioClipWrapper;
